﻿<template>
    <div>{{get_Passenger()}}</div>
    <div class="text-right">{{get_Price(trip_passenger.commission)}}</div>
    <div class="text-right">{{get_Price(trip_passenger.price)}}</div>
    <div class="text-right"><input type="checkbox" :checked="Cancel_Line()" @Click="Toggle_Cancellation()" class="focus:ring-action h-4 w-4 text-action border-grey-light rounded"></div>
</template>

<script lang="ts" src="./booking_line_passenger.ts"></script>